import type { Session } from './types';

function generateId(): string {
  const timestamp = Date.now().toString(36);
  const random = Math.random().toString(36).substring(2, 10);
  return `gs_${timestamp}_${random}`;
}

export class SessionManager {
  private session: Session | null = null;

  constructor(private projectId: string) {}

  start(): Session {
    this.session = {
      id: generateId(),
      projectId: this.projectId,
      startedAt: Date.now(),
      tags: [],
      metadata: {},
    };
    return this.session;
  }

  current(): Session {
    if (!this.session) {
      throw new Error('[Clintplay] No active session');
    }
    return this.session;
  }

  identify(userId: string, traits?: Record<string, unknown>): void {
    const session = this.current();
    session.userId = userId;
    session.userTraits = traits;
  }

  addTag(tag: string): void {
    const session = this.current();
    if (!session.tags.includes(tag)) {
      session.tags.push(tag);
    }
  }

  setMetadata(data: Record<string, unknown>): void {
    const session = this.current();
    session.metadata = { ...session.metadata, ...data };
  }

  getActiveSession(): { id: string; startedAt: number } | null {
    if (!this.session) return null;
    return {
      id: this.session.id,
      startedAt: this.session.startedAt,
    };
  }

  end(): void {
    this.session = null;
  }
}

